<template>
  <div>
    <div class="trial" @click="trial">
      <img src="../../static/img/Home/float.png" style="width: 100%;height: 100%;">
    </div>

    <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="swiperList.length!=0">
      <swiper-slide v-for="(item,index) in swiperList" :key="index">
        <img :src="item.imgUrl" alt="" class="swiper-img" :data-index="index" style="width: 100%;height: 100%;" />
      </swiper-slide>
      <!-- 常见的小圆点 -->
      <p class="swiper-pagination" v-for="(item,index) in swiperList" :key="index" slot="pagination"></p>

    </swiper>

    <!-- <div style="display: flex;justify-content: center;">
      <img src="../../static/img/Home/sy1.png" style="width: 100%;height: 100%;">
    </div>

    <img src="../../static/img/Home/sy2.png" style="width: 100%;height: 100%;"> -->
    <img src="../../static/img/Home/sy.png" style="width: 100%;height: 100%;">
    <!-- <div style="display: flex;justify-content: center;">
      <img src="../../static/img/Home/sy3.png" style="width: 100%;height: 100%;">
    </div> -->
    <!-- <div style="display: flex;justify-content: center;">
      <img src="../../static/img/Home/sy4.png" style="width: 100%;height: 100%;">
    </div> -->
    <div style="display: flex;justify-content: center; margin-bottom: 10vh;">
      <div style="width: 66%;display: flex;justify-content: flex-start;">
        <div style="width: 50%;">
          <div style="display: flow-root;font-size: 16px;">
            <div style="float:left;color: #3ACFF8;">特价促销</div>
            <div style="float: right; text-align: right;" @click="ToGoodsList">MORE</div>
          </div>
          <hr style="background-color: #3ACFF8;height: 1px;border: none;" />
          <div style="display: flex;justify-content: center;margin-top: 1rem;" class="goods">
            <subsidiary-nav :goodslist="Promotion"></subsidiary-nav>
          </div>
        </div>
        <div style="width: 50%;margin-left: 2%;">
          <div style="display: flow-root;font-size: 16px;">
            <div style="float:left;color: #FC92AA;">热卖HOT</div>
            <div style="float: right; text-align: right;" @click="ToGoodsList">MORE</div>
          </div>
          <hr style="background-color: #FC92AA;height: 1px;border: none;" />
          <div style="display: flex;justify-content: center;margin-top: 1rem;" class="goods">
            <subsidiary-nav :goodslist="HotGoods"></subsidiary-nav>
          </div>
        </div>
      </div>

      <div style="display: flex;justify-content: center;">

      </div>
    </div>
    <div style="display: flex;justify-content: center;margin-bottom: 10vh;">
      <iframe style="height: 80vh" frameborder=0 name="showHere" width="100%" scrolling=auto src="http://www.sunartedu.com/jiaoxutix/"></iframe>
    </div>
    <img src="../../static/img/Home/dividing.png" style="width: 100%;height: 100%; margin:1.5rem 0;">
    <swiper :options="swiperOption1" class="swiper-wrap activityswiper" ref="mySwiper1">
      <swiper-slide v-for="(item,index) in swiperList1" :key="index">
        <img v-lazy="item.imgUrl" alt="" class="swiper-img activityimg" />

      </swiper-slide>
      <!--  <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
  </div>
</template>

<script>
  import 'swiper/dist/css/swiper.css' //在全局没引入，这里记得要！
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import Common from '@/Global'
  import subsidiary from '../components/GoosList_HomeSub.vue';
  export default {
    components: {
      swiper,
      swiperSlide,
      subsidiaryNav: subsidiary,
    },
    created: function() {
      // debugger

      let m_SystemSetup = JSON.parse(sessionStorage.getItem('SystemSetup'))
      if (!m_SystemSetup) {
        this.$axios({
          method: 'get',
          url: Common.WebApiUrl + 'GetSystemSetup'
        }).then(function(res) {
          debugger
          if (res.data.length > 0) {
            sessionStorage.setItem('SystemSetup', JSON.stringify(res.data[0]))
          }
        }).catch(function(msg) {
          console.log(msg.status);
        });
      }
      let that = this
      this.$axios({
        method: 'get',
        url: Common.WebApiUrl + 'GetGoodsForHome',
      }).then(function(res) {
        // debugger
        if (res.data.Hot) {
          that.HotGoods = res.data.Hot
        }
        if (res.data.Promotion) {
          that.Promotion = res.data.Promotion
        }
        //that.goods = res.data
        //that.SelectData = res.data
        console.log(res.data);
      }).catch(function(msg) {
        console.log(msg.status);
      });
      // let c=this.$route.query
      // if (window.location.href.indexOf('code') >= 0) {
      // 	//如果url中包含code,则保存到store中
      // 	let code = window.location.href.split("?")[1];
      // 	code = code.substring(5, code.indexOf('&'));
      // 	//store.state.code = code;
      // 	console.log("code:"+code);
      // }
    },
    data() {
      const that = this;

        return {
          HotGoods: [],
          Promotion: [],
          imgIndex: 1,
          swiperOption: {
            //循环
            loop: true,
            //设定初始化时slide的索引
            initialSlide: 0,
            //自动播放
            autoplay: {
              delay: 30000,
              stopOnLastSlide: false,
              /* 触摸滑动后是否继续轮播 */
              disableOnInteraction: false
            },
            //滑动速度
            speed: 800,
            //滑动方向
            direction: "horizontal",
            //小手掌抓取滑动
            grabCursor: true,
            on: {

              //滑动之后回调函数
              slideChangeTransitionStart: function() {
                /* realIndex为滚动到当前的slide索引值 */
                that.imgIndex = this.realIndex - 1;

              },
            },
            //分页器设置
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
              type: "bullets"
            }
          },
          swiperList: [{
              imgUrl: './static/img/Home/swiper/banner1.png'
            },
            {
              imgUrl: './static/img/Home/swiper/banner2.png'
            },
            {
              imgUrl: './static/img/Home/swiper/banner3.png'
            },
            {
              imgUrl: './static/img/Home/swiper/banner4.png'
            },
          ],

          swiperOption1: {
            //循环
            //loop: true,
            //设定初始化时slide的索引
            //initialSlide: 0,
            slidesPerView: 5,
            //loopAdditionalSlides: 2,
            // slidesPerGroup: 3,
            //            loopFillGroupWithBlank: true,
            //自动播放
            autoplay: {
              delay: 10000,
              stopOnLastSlide: false,
              /* 触摸滑动后是否继续轮播 */
              disableOnInteraction: false
            },
            // spaceBetween: 30,
            //           slidesPerGroup: 5,

            //loopFillGroupWithBlank: true,
            // pagination: {
            //   el: '.swiper-pagination',
            //   clickable: true
            // },
            // navigation: {
            //   nextEl: '.swiper-button-next',
            //   prevEl: '.swiper-button-prev'
            // },
            //滑动速度
            // speed: 800,
            // //滑动方向
            // direction: "horizontal",
            // //小手掌抓取滑动
            // grabCursor: true,
            // on: {

            //   //滑动之后回调函数
            //   slideChangeTransitionStart: function() {
            //     //debugger
            //     /* realIndex为滚动到当前的slide索引值 */
            //     that.imgIndex = this.realIndex - 1;

            //   },
            //},
            //分页器设置
            // pagination: {
            //   el: ".swiper-pagination",
            //   clickable: true,
            //   type: "bullets"
            // }
          },
          swiperList1: [{
              imgUrl: './static/img/activity/a1.jpg'
            },
            {
              imgUrl: './static/img/activity/a2.jpg'
            },
            {
              imgUrl: './static/img/activity/a3.jpg'
            },
            {
              imgUrl: './static/img/activity/a4.jpg'
            },
            {
              imgUrl: './static/img/activity/a5.jpg'
            },
            {
              imgUrl: './static/img/activity/a6.jpg'
            },
            {
              imgUrl: './static/img/activity/a7.jpg'
            },
            {
              imgUrl: './static/img/activity/a8.jpg'
            },

          ],

        }
    },
    CreateData(e) {
      debugger
        const mobile = JSON.parse(sessionStorage.getItem('ismobile'))
        if (mobile == "1") {
          this.$router.push({
            name: 'mobile'
          });
        }
      },
    updated: function() {
      $.each($(".el-menu-item>div>span"), function(i, val) {

        if (val.innerHTML == "") {
          return true;
        }
        // debugger
        if (val.innerHTML == "加盟商登录") {
          //debugger
          let vli = val.parentElement.parentElement
          $(vli).addClass("rightmenuitem")
          $(vli).prop('id', "Login");
        } else if (val.innerHTML == "登录/注册") {
          // debugger
          let vli = val.parentElement.parentElement
          $(vli).addClass("rightmenuitem")
          //$(vli).prop('id', "Login");
        }
        // alert(i);
        // alert(val);
      });
      // $.each($(".el-submenu>.el-submenu__title>span"), function(i, val) {
      //   debugger
      //    if(val.innerHTML.indexOf("欢迎:")>=0)
      //    {
      //      let vli = val.parentElement.parentElement
      //      $(vli).addClass("rightmenuitem")
      //    }
      // })
    },
    methods: {
      ToGoodsList() {
        // this.$router.push({
        //   name: 'adduserinfo',
        // });
        this.$router.push({
          name: 'Online',
        });
      },
      trial() {
        debugger
        const m_UserInfo = JSON.parse(sessionStorage.getItem('userinfo'))
        if (m_UserInfo) {
          location.href = 'https://www.sunartedu.com/class/piano2016/demo/index.html'
        } else {
          this.$router.push({
            name: 'login',
            query: {
              mode: '01',
            }
          });
        }

      }

    },

  }
</script>

<style scoped>
  h4 {
    margin-top: 0px;
    margin-bottom: 0px;
    line-height: 2;
  }

  h2 {
    margin-top: 0px;
    margin-bottom: 0px;
    line-height: 2;
  }

  .goods>>>.container .list {
    width: 45%;
  }

  .trial {
    position: absolute;
    z-index: 100;
    margin-left: 65%;
  }

  .trial :hover {
    cursor: pointer;
  }

  .activityimg {
    width: 18.75rem;
  }

  .activityswiper {
    margin-bottom: 10vh;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue